import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"
import { useLocation } from "@reach/router"
import queryString from "query-string"
import Layout from "../../components/shared/layout"
import SEO from "../../components/SEO/SEOPage"
import Img from "gatsby-image"
import styled from "@emotion/styled"
import { breakpoints, ContentStyles, ContentStylesExt, featuredWrapper, wrapper, wrapper1200 } from "../../utils/style"
import Breadcrumbs from "../../components/shared/Breadcrumbs"
import Auth from "../../components/Auth/Auth"
import RegistrationFormStatic from "../../components/Auth/Form/RegistrationFormStaticCastrated"
import Parallax from "../../components/shared/Parallax"
import Steps from "../../components/Content/Register/Steps"
import { lineCabinetRegister } from "../../components/Auth/Config"

const FeaturedWrapper = styled("div")`
  ${featuredWrapper}
  position: relative;
  margin: 15px 0;
  .gatsby-image-wrapper {
    border-radius: 24px;
  }
  img {
    border-radius: 24px;
  }
  h1 {
    margin-top: 30px;
  }
  @media (max-width: ${breakpoints.md}) {
    .gatsby-image-wrapper,
    img {
      border-radius: 10px;
    }
  }
  @media (max-width: ${breakpoints.xs}) {
    h1 {
      font-size: 1.5rem;
      margin-top: 20px;
      left: 20px;
    }
  }
`

const NoFeaturedWrapperReg = styled("div")`
  .top-block {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row wrap;
    margin-bottom: 40px;
    .col-right {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    p {
      margin-right: 40px;
    }
  }
  .register-wrap {
    background: linear-gradient(215.08deg, #a513bf 0%, #421cc1 100%);
    border-radius: 4px;
    padding: 22px 6px;
    margin-bottom: 40px;
  }
  .auth-container {
    .auth-wrapper {
      text-align: left;
      width: auto;
      margin: 10px 0;
    }
    .button {
      margin-left: 0;
    }
  }
  @media (max-width: ${breakpoints.lg}) {
    .top-block {
      flex-basis: 100%;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    padding: 20px 0;
    background: none;
  }
  @media (max-width: ${breakpoints.sm}) {
    .top-block {
      .col {
        flex-basis: 100%;
      }
    }
  }
  @media (max-width: ${breakpoints.xs}) {
    padding: 0 0 20px 0;
    .top-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .auth-container {
        height: auto;
      }
    }
  }
`

const SaButtonWrap = styled("div")`
  padding: 35px 0;
  text-align: center;
   @media (max-width: ${breakpoints.xs}) {
     padding: 10px 0 20px;
     .button {
        white-space: normal;
        height: auto;
        padding: 12px 25px;
        width: 100%;
      }
   }
`

const WrapperDesktop = styled("div")`
  ${wrapper1200}
`

const ContentWrapper = styled("div")`
  ${wrapper}
  ${ContentStyles}
  ${ContentStylesExt}
  padding: 0;
  margin-bottom: 40px;
  img {
     width: 100%;
  }
`

const PageTemplate = ({ data, pageContext }) => {
  const currentPage = data.wordpressPage
  const featuredMedia = currentPage.featured_media
  const metaTitle =
    currentPage.yoast_meta && currentPage.yoast_meta.yoast_wpseo_title
      ? currentPage.yoast_meta.yoast_wpseo_title
      : currentPage.title + "- " + process.env.OWNER
  const metaDesc =
    currentPage.yoast_meta && currentPage.yoast_meta.yoast_wpseo_metadesc
      ? currentPage.yoast_meta.yoast_wpseo_metadesc
      : ""
  const socialImage = currentPage.featured_media?.localFile?.publicURL
  const breadcrumbs = pageContext.breadcrumbs
  const page_title = pageContext.page_title
  const step_1 = currentPage.acf.step_1
  const step_2 = currentPage.acf.step_2
  const step_3 = currentPage.acf.step_3

  const location = useLocation();
  const parsedSearch = queryString.parse(location.search);
  const [registerFsOnly, setRegisterFsOnly] = useState(false);
  useEffect(() => {
    setRegisterFsOnly('register_type' in parsedSearch && parsedSearch.register_type === 'onsitegames');
  }, []);

  return (
    <Layout>
      <SEO
        title={metaTitle}
        description={metaDesc}
        pathname={currentPage.path}
        breadcrumbs={breadcrumbs}
        socialImage={socialImage}
      />
      <Parallax />
      <WrapperDesktop>
        <Breadcrumbs breadcrumbs={breadcrumbs} page_title={page_title} />
        {featuredMedia &&
        featuredMedia.localFile &&
        featuredMedia.localFile.childImageSharp &&
        featuredMedia.localFile.childImageSharp.fluid ? (
          <div>
            <FeaturedWrapper>
              <Img
                fluid={featuredMedia.localFile.childImageSharp.fluid}
                alt={
                  currentPage.featured_media.alt_text
                    ? currentPage.featured_media.alt_text
                    : currentPage.title
                }
                fadeIn={false}
                loading="eager"
              />
              <h1 dangerouslySetInnerHTML={{ __html: page_title }} />
            </FeaturedWrapper>
            <SaButtonWrap>
              <a
                className="button pink-button"
                href={lineCabinetRegister}
                target="_blank"
                rel="noopener noreferrer"
              >
                สมัครสมาชิกเล่นได้เงินจริงด้วย Lnwasia Wallet
              </a>
            </SaButtonWrap>
            <NoFeaturedWrapperReg>
              <div className="top-block">
                <div className="col">
                  <h1 dangerouslySetInnerHTML={{ __html: currentPage.title }} />
                </div>
                <div className="col col-right">
                  <p>เล่นเกมฟรีพร้อมแลกเปลี่ยนเป็นเงินจริง</p>
                  <div className="auth-container">
                    <Auth hideRegButton={true} />
                  </div>
                </div>
              </div>
              {registerFsOnly &&
              <div className="register-wrap">
                <RegistrationFormStatic />
              </div>
              }
            </NoFeaturedWrapperReg>
          </div>
        ) : (
          <>
            <SaButtonWrap>
              <a
                className="button pink-button"
                href={lineCabinetRegister}
                target="_blank"
                rel="noopener noreferrer"
              >
                สมัครสมาชิกเล่นได้เงินจริงด้วย Lnwasia Wallet
              </a>
            </SaButtonWrap>
            <NoFeaturedWrapperReg>
              <div className="top-block">
                <div className="col">
                  <h1 dangerouslySetInnerHTML={{ __html: currentPage.title }} />
                </div>
                <div className="col col-right">
                  <p>เล่นเกมฟรีพร้อมแลกเปลี่ยนเป็นเงินจริง</p>
                  <div className="auth-container">
                    <Auth hideRegButton={true} />
                  </div>
                </div>
              </div>
              {registerFsOnly &&
              <div className="register-wrap">
                <p>กรุณากรอกข้อมูล</p>
                <RegistrationFormStatic />
              </div>
              }
            </NoFeaturedWrapperReg>
          </>
        )}

        <Steps step_1={step_1} step_2={step_2} step_3={step_3} />

        <ContentWrapper>
          <div dangerouslySetInnerHTML={{ __html: currentPage.content }} />
        </ContentWrapper>
      </WrapperDesktop>
    </Layout>
  )
}

export default PageTemplate

export const pageQuery = graphql`
  query($id: String!, $contentImages: [Int]) {
    wordpressPage(id: { eq: $id }) {
      wordpress_id
      title
      content
      date(formatString: "MMMM DD, YYYY")
      path
      yoast_meta {
        yoast_wpseo_title
        yoast_wpseo_metadesc
      }
      acf {
        page_template
        step_1
        step_2
        step_3
      }
      featured_media {
        alt_text
        localFile {
          publicURL
          childImageSharp {
            fluid(maxWidth: 1400) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    }
    allWordpressWpMedia(filter: { wordpress_id: { in: $contentImages } }) {
      edges {
        node {
          wordpress_id
          alt_text
          source_url
          localFile {
            publicURL
            childImageSharp {
              fluid(maxWidth: 1400) {
                ...GatsbyImageSharpFluid_withWebp_noBase64
                presentationWidth
              }
            }
          }
        }
      }
    }
  }
`
